import { ref }                  from 'vue'
import { defineStore }          from 'pinia'
import { useConfigStore }       from '@/stores/config'
import { useRequestsStore }     from '@/stores/requests'
import { useTokenStore }        from '@/stores/token'

export const useCarHistoryStore = defineStore('car-history', () => {

    const configStore   = useConfigStore()
    const requestsStore = useRequestsStore()
    const tokenStore    = useTokenStore()

    const statesHistory           = ref(null)
    const statesHistoryPart       = ref(null)
    const statesHistoryProcess    = ref(false)
    const statesHistoryMsg        = ref({})

    async function readStatesHistory(payload) {

        statesHistoryProcess.value = true
        const token = tokenStore.access

        if(token) {

            let params = ''

            if(payload) {
                for( let param in payload) {
                    if(param == 'key_array') {
                        payload.key_array.map( item => {
                            params.length ?
                                params += '&key_array=' + item :
                                params = '?key_array=' + item
                        })
                    } else {
                        params.length ?
                            params += '&' + param + '=' + payload[param] :
                            params = '?' + param + '=' + payload[param]
                    }
                }
            }

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/cars/points/track${params}`, 
                method: 'GET', 
                token
            })

            if(!request.error) {

                statesHistoryPart.value = request
                statesHistoryMsg.value = { success: true, text: '' }

            } else {

                statesHistory.value = null
                statesHistoryPart.value = null
                statesHistoryMsg.value = { success: false }

                switch(request.error) {

                    case 'ECarPointNotFound': 
                        statesHistoryMsg.value.text = 'HISTORY_EMPTY_POINTS'
                        break

                    default:
                        statesHistoryMsg.value.text = request.error
                        break
                }
            }

            statesHistoryProcess.value = false

        } else {
            statesHistoryMsg.value = { success: false, text: 'EUnauthRequest' }
        }
    }

    const setStatesHistory      = data => statesHistory.value      = data
    const setStatesHistoryPart  = data => statesHistoryPart.value  = data
    const setStatesHistoryMsg   = data => statesHistoryMsg.value   = data

    return {

        statesHistory,
        statesHistoryPart,
        statesHistoryProcess,
        statesHistoryMsg,
        readStatesHistory,
        setStatesHistory,
        setStatesHistoryPart,
        setStatesHistoryMsg
    }
})
